var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ionic-icon d-inline-flex align-center justify-center"},[_c('ion-icon',_vm._b({style:({
      color: 'inherit',
      fontSize: _vm.size
    }),attrs:{"name":!_vm.icon ? 'folder-outline' : _vm.icon.name}},'ion-icon',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }